import DatatableV1 from "../../../../components/form_builder/elements/datatable/DatatableV1.vue";

export default {
  componentName: "fb-datatable-v1",
  component: DatatableV1,
  defaultAttrs: {
    properties: {
      label: "Label",
      description: "",
      columns: [
        {
          text: "Column 1",
          field: "column1"
        },
        {
          text: "Column 2",
          field: "column2"
        },
        {
          text: "Column 3",
          field: "column3"
        }
      ],
      value: [],
      required: false,
      hidden: false,
      style: {},
      eFormEditable: true,
      dependentProperties: {}
    }
  },
  gridAttrs: {
    type: "template",
    width: 50,
    template: ({ value }) => (value ? `${value.length} rows` : "")
  },
  validate: ({ value, properties }) => {
    const errors = [];
    if (properties.required && value.length == 0)
      errors.push("This field is required");
    return errors;
  }
};
